module.exports = __webpack_public_path__ + "media/images/result_sets/circles/1n2n7n4r-f679d3073122eddb62990be458445bd7.svg";